import * as z from 'zod';

import { infrastructureQueryLinkerSchema } from '@/_pages/settings/infrastructures/shared';
import { registrarQueryLinkerSchema } from '@/_pages/settings/registrars/shared';
import { systemUserQuerySchema } from '@/_pages/system-users/shared';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { domainQueryLinkerSchemaWithExData } from './domain-query-linker-schema';
import { hostingManagementQuerySchema } from './hosting-management-schema';
import { registrarManagementQuerySchema } from './registrar-management-schema';

export const domainQuerySchema = z.object({
  ...domainQueryLinkerSchemaWithExData.shape,

  hosting_management: hostingManagementQuerySchema.nullable(),
  registrar_management: registrarManagementQuerySchema.nullable(),

  expiration_date: z.string().nullable(),
  registrar_notes: z.string().nullable(),
  hosting_notes: z.string().nullable(),
  registrar_username: z.string().nullable(),
  registrar_password: z.string().nullable(),
  registrar_pin: z.string().nullable(),
  registrar_id: z.number().nullable(),
  registrar: registrarQueryLinkerSchema.nullish(),
  infrastructure_id: z.number().nullable(),
  infrastructure: infrastructureQueryLinkerSchema.nullish(),
  // TODO: CONFIRM BELOW FIELDS
  client_id: z.number().nullable(),
  client: companyQueryLinkerSchema.nullish(),
  application_id: z.number().nullable(),
  application: z.object({ id: z.number() }).nullish(),

  creator_id: z.number().nullable(),
  created_by: systemUserQuerySchema.nullish(),
});

export type DomainQuerySchema = z.infer<typeof domainQuerySchema>;

export const domainQueryAllSchema = paginatedResponseSchema(domainQuerySchema);

export type DomainQueryAllSchema = z.infer<typeof domainQueryAllSchema>;
